<template>
    <div class="colorpicker" v-on-clickaway="away">
        <div class="chosen" @click="openPicker()">
            <div class="color"><span :style="{'background-color':handler}"></span></div>
            <input type="text" v-model="handler" @input="updateObj" @keypress.enter="active=false">
        </div>

        <div class="float" v-if="active">
            <div class="presets">
				<div v-for="preset in colorPresets" @click="setPreset(preset)" :title="preset">
                    <span :style="{backgroundColor:preset}"></span>
                </div>
			</div>
            <picker-chrome  v-model="obj" @input="input" />
        </div>
    </div>
</template>
<style scoped>
.chosen {
    cursor: pointer;
    font-size: 0.8em;
    padding: 5px;
    background: #fff;
    display:flex;
    align-items: center;
}
.chosen input {
    border:none;
    width:100%;
}
.chosen input:focus {
    outline:none;
    outline-color: red;
}
.chosen .color {
    width:20px;
    height:20px;
    flex-shrink: 0;
    margin-right:5px;
    background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA2UlEQVQ4T3VSWxKDMAgkt2jufzeplygdCOC6Rn4cBdZ9MI7jMNnVEBETmXPeuz7tPS8TGQ2QC93MgfmZa4EWa24B4EAN5jMAsJDvcAZKEhBAUkItFXUAvDPwRrHJofCAQJ8egCmxB5JCAuonwy8GaVr3OQWWkaBXChv6/qljJHODlZM1M6uXpg9s9KvbM6mPw362YuTKP+ipy4NdeYzBgHMGUx8AdDPvEhI0JPAVNn9n4BLKwNIOkhqAZxJk7wFEpqqP47odUnvwknMD8J00AzQRQTCF0rzx4g+2DYx4LXH0YgAAAABJRU5ErkJggg==");
}
.chosen .color span { width:100%; height:100%; display:block; }

.presets { display: flex; margin:0 -6px 8px; flex-wrap: wrap; }
.presets div {
    cursor: pointer;
    height:24px;
    border:1px solid #B2B2BD;
    margin: 0 2.6px 6px;
    overflow: hidden;
    border-radius:2px;
    width: 10.4%;
    margin: 0 calc(1%) 6px;
    background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA2UlEQVQ4T3VSWxKDMAgkt2jufzeplygdCOC6Rn4cBdZ9MI7jMNnVEBETmXPeuz7tPS8TGQ2QC93MgfmZa4EWa24B4EAN5jMAsJDvcAZKEhBAUkItFXUAvDPwRrHJofCAQJ8egCmxB5JCAuonwy8GaVr3OQWWkaBXChv6/qljJHODlZM1M6uXpg9s9KvbM6mPw362YuTKP+ipy4NdeYzBgHMGUx8AdDPvEhI0JPAVNn9n4BLKwNIOkhqAZxJk7wFEpqqP47odUnvwknMD8J00AzQRQTCF0rzx4g+2DYx4LXH0YgAAAABJRU5ErkJggg==");
}
.presets span {
    display:block;
    height:100%;
}

.colorpicker { position:relative;}
.float { position: absolute;
		top:100%;
        top:calc(100% + 5px);
		border-radius: 4px;
		padding:15px;
		z-index:4;
		background:#fff;
		width: 255px;
		box-shadow: 0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3);
}
.vc-chrome { box-shadow: none; margin:0 auto; }



</style>
<style>
	.vc-chrome-saturation-wrap { padding-bottom:96px !important;}
    .vc-chrome-fields-wrap { display:none !important;}
</style>
<script>

import { Chrome } from 'vue-color';
import { mixin as clickaway } from 'vue-clickaway';
export default {
  props: ['config', 'name', 'value'],
    mixins: [ clickaway ],
  components:{
    'picker-chrome':Chrome,
  },
  data(){
      return {
          handler:'',
          obj:{},
          active:false,
      }
  },
  computed:{
      colorPresets(){
          return this.$store.getters.colorPresets;
      }
  },

  mounted(){
    this.handler = this.value;
    this.obj = this.value;
    document.addEventListener('keydown',(e)=>{ if(e.keyCode==27) this.active = false; })

  },

  methods:{

    away(){
        this.active=false;
    },
    openPicker(){

        this.active = true;
        //update color picker presets
        this.$store.dispatch('getColorPresets');
    },
    updateObj(){
        this.obj = this.handler;
        this.$emit('change',this.handler);
    },
    setPreset(newVal){
        this.handler = newVal;
        this.obj = newVal;
        this.$emit('change',this.handler);
    },

    componentToHex(c) {
        var hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
    },

    rgbToHex(r, g, b) {
        return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
    },


    input(){
        if(this.obj.a==1){
            this.handler = this.obj.hex;
        } else {
            this.handler = `rgba(${this.obj.rgba.r},${this.obj.rgba.g},${this.obj.rgba.b},${this.obj.rgba.a})`;
        }
        this.$emit('change',this.handler);
    },
  }

}
</script>
